import moment from "moment";

export const getDayNameFromNumber = (dayNumber) =>
  moment().day(dayNumber).format("ddd");

export const getNonExcludedDayNumbersFromExcludedDays = (excludedDays) =>
  [0, 1, 2, 3, 4, 5, 6].filter(
    (dayNumber) => !excludedDays.includes(dayNumber)
  );
